import TabPage from "./../../factories/tab-page";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ShiftbookRecipientTab extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
    }
    Bao = Bao;
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() { return "RoleOrganisation"; }
    CustomFilter() {
        return null;
    }

    /**
     * This method is used to save selected item from search dialog
     * @param searchItem Selected item from search dialog
     * @returns JQueryPromise<boolean>
     */
    protected SaveSelectedItem(searchItem: any): JQueryPromise<any> {
        return Bao.post("ShiftbookRecipientTab/SaveItemToSession", JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            roleId: ko.unwrap(searchItem.RoleId),
            shiftbookId: ko.unwrap(searchItem.ShiftbookId),
        }), (serverResult: {
            Message: string;
            Result: boolean;
        }) => {
            if (serverResult.Result) {
                return true;
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, serverResult.Message, "info");
                return false;
            }
        });
    }
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    };
}
export default ShiftbookRecipientTab;